import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _defineProperty from "babel-runtime/helpers/defineProperty";

var _headers;

/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Cart methods
 * -----------------------------------------------------------------------------
 *
 * @namespace cart
 */

import axios from 'axios';

// IE11 bug: we need to disable cache for this request
var axiosConfig = {
  headers: (_headers = {
    'Cache-Control': 'must-revalidate'
  }, _defineProperty(_headers, "Cache-Control", 'no-cache'), _defineProperty(_headers, "Cache-Control", 'no-store'), _defineProperty(_headers, "Pragma", 'no-cache'), _headers)
};

var cartMethods = {
  data: function data() {
    return {
      isCartAjaxed: false,
      isSubscriptionItem: false,
      loadingEvent: null,
      cart: {},
      motivationbartext: null,
      motivationbarpercentage: null
    };
  },


  methods: {
    _initCart: function _initCart() {
      var isCartAjaxed = $('[data-template="cart"]').data('cart-ajaxed');

      if (isCartAjaxed) {
        app.isCartAjaxed = true;
      }

      app._getCartData();
    },
    _mergeObjs: function _mergeObjs(def, obj) {
      if (typeof obj === 'undefined') {
        return def;
      } else if (typeof def === 'undefined') {
        return obj;
      }
      for (var i in obj) {
        if (obj[i] != null && obj[i].constructor === Object) {
          def[i] = app._mergeObjs(def[i], obj[i]);
        } else {
          def[i] = obj[i];
        }
      }
      return def;
    },
    _getCartDefault: function _getCartDefault() {
      return axios.get('/cart.js', axiosConfig);
    },
    _getCartExtra: function _getCartExtra() {
      return axios.get('/cart?view=extra.json', axiosConfig);
    },


    /**
     * Get the cart data json object
     */
    _getCartData: function _getCartData() {

      // we make our own enhanced version of the cart object.
      // we are merging Shopify's default cart object
      // and some more additional data like product options and metafields
      // eslint-disable-next-line promise/catch-or-return
      axios.all([app._getCartDefault(), app._getCartExtra()]).then(axios.spread(function (basic, extra) {
        // Both requests are now complete
        var basicCartData = basic.data;
        var mergedItems = app._mergeObjs(basic.data.items, extra.data.items);
        basicCartData.items = mergedItems;
        var cart_has_package = false;
        var package_variant = '';

        setTimeout(function () {
          if (basicCartData.items.length > 0) {
            $('[data-package-item]').each(function () {
              $(this).removeClass('d-none');
            });
          } else {
            $('[data-package-item]').each(function () {
              $(this).addClass('d-none');
            });
          }
        }, 1000);

        basicCartData.items.forEach(function (item) {
          item.product_title = item.product_title.replace('Auto renew', '');
          if (item.product_title.indexOf('Gift Package') > 1) {
            app.cartHasGift = true;
          }
          if (!item.properties) {
            item.properties = [];
          }
          item.stateLevel = '';
          if (item.product_title.indexOf('XL') > -1) {
            if (item.variant_title != null) {
              if (item.variant_title.indexOf('Original') > -1) {
                item.stateLevel = 'Original Hydroponic.';
              } else if (item.variant_title.indexOf('Central') > -1) {
                item.stateLevel = 'Central Local.';
              }if (item.variant_title.indexOf('Local') > -1) {
                item.stateLevel = 'Local.';
              }
            }
          }
          if (item.properties.subscription_id != undefined) {
            app.isSubscriptionItem = true;
          }
          if (item.product_title.trim() == 'DoggieLawn Package Protection') {
            cart_has_package = true;
            package_variant = item.variant_title;
          } else if (item.product_title == 'Standard DoggieLawn' || item.product_title == 'Medium DoggieLawn' || item.product_title == 'Large DoggieLawn' || item.product_title == 'XL DoggieLawn' || item.product_title == 'DoggieLawn' || item.product_title == 'DoggieLawn New Puppy Bundle') {
            app.has_package = true;
            if (item.variant_title != null && item.product_title != 'DoggieLawn') {
              app.selected_package = item.variant_title;
            } else if (item.variant_title != null && item.product_title == 'DoggieLawn') {

              if (item.properties.shipping_interval_frequency == 1) {
                app.selected_package = 'Every Week';
              } else if (item.properties.shipping_interval_frequency == 2 || item.properties.shipping_interval_frequency == 3 || item.properties.shipping_interval_frequency == 4) {
                app.selected_package = "Every " + item.properties.shipping_interval_frequency + " Weeks";
              } else {
                app.selected_package = item.variant_title;
              }
            }
          }
        });
        if (cart_has_package) {
          app.has_package = false;
        }

        setTimeout(function () {
          if (cart_has_package && basicCartData.items.length === 1) {
            $('.package_remove')[0].click();
          }
          if (!cart_has_package && basicCartData.items.length >= 1) {
            app.has_package = true;
          }
          // if(cart_has_package && app.selected_package != package_variant){
          //   $('.package_remove')[0].click();
          // }
        }, 1000);

        app.cart = basicCartData;
        if (app.salesMotivator.Enabled) {
          app._initmotivationbar();
        }
        if (!app.cartHasGift) {
          var cart_attributes = {
            attributes: {
              "Ricipient's Email": '',
              'Gift note': ''
            }
          };
          axios.post('/cart/update.js', cart_attributes).then(function (response) {});
        }
      }));
    },
    _gaAddEvent: function _gaAddEvent() {
      var variant_price = app.currentVariant.price / 100;
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'USD',
          value: variant_price,
          items: [{
            item_id: app.currentVariant.sku,
            item_name: app.product.title,
            affiliation: 'Google Merchandise Store',
            item_brand: app.product.vendor,
            item_variant: app.currentVariant.id,
            price: variant_price,
            quantity: 1
          }]
        }
      });
    },


    /**
     * Event to add a variant to the cart
     * adds item properties from hidden fields automatically
     *
     * @param  {number} variantId - current variant id
     */
    _addToCart: function _addToCart(variantId, event, reload, check, pr_title, sku, vendor, productPrice) {
      if (document.getElementById('fake_shipping_interval_frequency_') && !event.target.hasAttribute('packageProtectionProduct')) {
        console.log(event.target.hasAttribute('packageProtectionProduct'), 'ldjaosdjhaksjdnSKJhdaihdhbhsafghsyhgrjhgfjhsdgfjhdgfdhgfdhgfdhgfhdgfhjdgfhdgfh  ');
        var selectElement = document.getElementById('fake_shipping_interval_frequency_');
        var selectedOption = selectElement.options[selectElement.selectedIndex];
        var frequencyQuantity = selectedOption.getAttribute('frequencyquantity');
        console.log(frequencyQuantity, 'frequencyQuantityfrequencyQuantityfrequencyQuantityfrequencyQuantity');
        localStorage.setItem('frequencyQuantity', frequencyQuantity);
      }

      var $current_button = $(event.currentTarget);
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      var $current_text = $(event.currentTarget).text();
      var $form = $(event.currentTarget).closest(app.selectors.productForm);
      var $qtyEl = $form.find(app.selectors.qtyInput);
      var qtyValue = $qtyEl.val() || 1;
      var productCartLimit = $(event.currentTarget).attr('data-cart-limit') || null;
      var cartProduct = app.cart.items.find(function (x) {
        return x.variant_id === variantId;
      });
      var sellingId = '';
      var variantIdCustom = '';
      // console.log(event.target.getAttribute('sellingplan'), typeof (event.target.getAttribute('sellingplan')), 'eventtftftftftft');
      if (event.target.getAttribute('sellingplan') === '0') {
        if (event.target.hasAttribute('packageProtectionProduct')) {
          sellingId = null;
          variantIdCustom = localStorage.getItem('packageProtectionVarId');
        } else {
          console.log(event.target.getAttribute('sellingplan'), event.target.getAttribute('sellingplan') === '0', 'eventtftftftftft');
          sellingId = null;
          console.log(event.target.getAttribute('variant-id'));
          document.querySelector('.varianrInputCustom') ? variantIdCustom = document.querySelector('.varianrInputCustom').getAttribute('name') : variantIdCustom = event.target.getAttribute('variant-id');
        }
      } else if (document.querySelector('[name="selling_plan"]')) {
        if (event.target.hasAttribute('packageProtectionProduct')) {
          if (localStorage.getItem('frequencyQuantity') === 'null') {
            console.log('packageProtectionProduct ifff', localStorage.getItem('packageProtectionVarId'));
            sellingId = null;
            variantIdCustom = localStorage.getItem('packageProtectionVarId');
          } else {
            console.log('packageProtectionProduct else', localStorage.getItem('packageProtectionVarId'));
            sellingId = variantId;
            variantIdCustom = localStorage.getItem('packageProtectionVarId');
          }
        } else {
          console.log('else if packageProtectionProduct elseeooooooooo');
          document.querySelectorAll('input[name="selling_plan"]').forEach(function (each) {
            if (each.checked && each.value) {
              console.log(each.checked, 'each.checkedeach.checked');
              sellingId = document.querySelector('.deliveryFrequency').value;
            }
          });
          console.log(!sellingId, 'sellingIdsellingIdsellingIdsellingId');
          if (!sellingId) {
            localStorage.setItem('frequencyQuantity', null);
          }
          // localStorage.setItem('frequencyQuantity', null);
          document.querySelector('.varianrInputCustom') ? variantIdCustom = document.querySelector('.varianrInputCustom').getAttribute('name') : variantIdCustom = event.target.getAttribute('variant-id');
        }
        // variantIdCustom = document.querySelector('.varianrInputCustom').getAttribute('name');
      } else {
        // eslint-disable-next-line no-lonely-if
        console.log('else ');
        if (!document.querySelector('[data-details-product]')) {
          console.log('else if if', event.target.hasAttribute('collectionquickadd'));
          if (localStorage.getItem('frequencyQuantity') === 'null' && event.target.hasAttribute('packageProtectionProduct')) {
            console.log('raman', localStorage.getItem('frequencyQuantity') === 'null', event.target.hasAttribute('packageProtectionProduct'));
            sellingId = null;
            variantIdCustom = localStorage.getItem('packageProtectionVarId');
            console.log(variantIdCustom, 'variantIdCustomvariantIdCustomvariantIdCustomvariantIdCustom');
          } else if (event.target.hasAttribute('collectionquickadd')) {
            if (event.target.closest('.card-footer').querySelector('.collectionquickadd')) {
              console.log('evennnntttttt', event.target.hasAttribute('collectionquickadd'));
              var _selectElement = event.target.closest('.card-footer').querySelector('.collectionquickadd');
              var _selectedOption = _selectElement.options[_selectElement.selectedIndex];
              console.log(_selectedOption.getAttribute('data-id'));
              console.log(_selectedOption.getAttribute('data-id'));
              variantIdCustom = _selectedOption.getAttribute('data-id');
            } else {
              variantIdCustom = event.target.getAttribute('aria-label');
            }
          } else if (window.location.href.includes('/cart')) {
            sellingId = variantId;
            variantIdCustom = localStorage.getItem('packageProtectionVarId');
          } else {
            sellingId = document.querySelector('#selected_frequency').getAttribute('sellingPlanId');
            console.log('triiiiiiiii', sellingId, variantIdCustom);
            variantIdCustom = document.querySelector('.varianrInputCustom').getAttribute('name');
          }
        } else if (event.target.hasAttribute('packageProtectionProduct')) {
          sellingId = variantId;
          variantIdCustom = localStorage.getItem('packageProtectionVarId');
        } else {
          console.log('else if else');
          console.log(variantIdCustom, sellingId, 'ddsdsdsdssddsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsdsd');
          sellingId = document.querySelector('#selected_frequency').getAttribute('sellingPlanId');
          variantIdCustom = document.querySelector('#selected_frequency').getAttribute('variant-id');
        }
        // const freeVarIdd = event.target.getAttribute('freevariantid');
      }

      console.log(variantIdCustom, 'raman variantIdCustom');
      var totalQty = cartProduct ? Number(qtyValue) + Number(cartProduct.quantity) : qtyValue;
      var properties = {};
      Shopify.queue = [];

      if (app.currentTemplate === 'product') {
        this._gaAddEvent();
      }

      var shaEmail = $('[data-sha-email]').attr('data-sha-email');
      var shaPhone = $('[data-sha-email]').attr('data-sha-email');

      // add cart limit property
      if (productCartLimit) {
        properties.cart_limit = productCartLimit;
      }

      // check if item has product limit assigned
      if (app._productHasCartLimit(totalQty, productCartLimit)) {
        return;
      }

      app.isLoading = true;
      app.isCartAdded = true;
      app.loadingEvent = 'cartAdding';

      // Pass all properties to the cart line item
      if (app.currentTemplate !== 'collection') {
        $.each($('[data-product-form] input[name*="properties"]').serializeArray(), function () {
          var name = this.name.replace('properties[', '').replace(']', '');
          properties[name] = this.value;
        });
      } else {
        var prop = $(event.currentTarget).closest('.card-footer').siblings('input[name*="properties"]');
        $.each(prop.serializeArray(), function () {
          var name = this.name.replace('properties[', '').replace(']', '');
          properties[name] = this.value;
        });
      }

      // ReCharge Integration
      // if product is a subscription one use the reCharge Discount VariantId
      if ('subscription_id' in properties) {
        properties.shipping_interval_frequency = $('[name="properties[shipping_interval_frequency]"]').val();
        variantId = app.reChargeDiscountVariantId;
      }

      // eslint-disable-next-line eqeqeq
      if (app.pickYourPlan.shipping_interval_frequency != '') {
        properties.shipping_interval_frequency = app.pickYourPlan.shipping_interval_frequency;
      }

      // eslint-disable-next-line eqeqeq
      if (app.pickYourPlan.shipping_interval_unit_type != '') {
        properties.shipping_interval_unit_type = app.pickYourPlan.shipping_interval_unit_type;
      }

      // eslint-disable-next-line eqeqeq
      if (app.pickYourPlan.subscription_id != '') {
        properties.subscription_id = app.pickYourPlan.subscription_id;
      }
      if (app.pickYourPlan.grass.selectedState != '') {
        properties.state = app.pickYourPlan.grass.selectedState;
      }
      if (!location.href.includes('cart')) {
        // eslint-disable-next-line eqeqeq
        if (variantId != '' && variantId != null) {
          console.log(variantId, 'variantIdvariantIdvariantId');
          if (!document.querySelector('.cart-drawer ').classList.contains('opened') && app.currentTemplate == 'product' || app.currentTemplate === 'collection') {
            if (app.product.handle == 'doggielawn-bundle' && $('.rc_option__recurring').hasClass('active')) {
              var subscription_bundle_id = $('.cur_discount_price').attr('data-variant_id');
              Shopify.queue.push({
                variantId: subscription_bundle_id,
                prop: properties
              });
            } else if (app.product.handle == 'disposable-doggielawn' && $('.rc_option__recurring').hasClass('active')) {
              var disposable_freq = $('[name="properties[shipping_interval_frequency]"]').val();
              var disposable_variant = 'Every week';
              if (disposable_freq != 1) {
                disposable_variant = "Every " + disposable_freq + " weeks";
              }
              var dispo_product_html = JSON.parse($('[data-disposable-pr].active').html());
              var dispo_product = dispo_product_html.product;
              var dispo_variants = dispo_product.variants;
              var disposable_variant_id = '';
              dispo_variants.forEach(function (variant) {
                if (variant.title == disposable_variant) {
                  disposable_variant_id = variant.id;
                }
              });
              Shopify.queue.push({
                variantId: disposable_variant_id,
                prop: properties
              });
            } else {

              Shopify.queue.push({
                variantId: variantId,
                prop: properties
              });
            }
          } else {
            // eslint-disable-next-line eqeqeq
            if (app.currentTemplate == 'cart' || document.querySelector('.cart-drawer ').classList.contains('opened')) {
              Shopify.queue.push({
                variantId: app.reChargeDiscountVariantId,
                prop: properties
              });
            } else {

              // push the default variantId to the Shopify queue
              // eslint-disable-next-line no-lonely-if
              if (pr_title != undefined && !document.querySelector('.cart-drawer ').classList.contains('opened')) {
                if (app.pickYourPlan.frequency.frequencyId != '' && pr_title.indexOf('Disposable') > -1) {
                  Shopify.queue.push({
                    variantId: variantId,
                    prop: properties
                  });
                }
              } else {
                Shopify.queue.push({
                  variantId: variantId
                });
              }
            }
            // eslint-disable-next-line eqeqeq
            if (pr_title == undefined && !document.querySelector('.cart-drawer ').classList.contains('opened')) {
              if (app.pickYourPlan.frequency.frequencyId != '') {
                Shopify.queue.push({
                  variantId: app.pickYourPlan.frequency.frequencyId,
                  prop: properties
                });
              }
            }
          }
        } else {
          // push the default variantId to the Shopify queue
          // eslint-disable-next-line no-lonely-if
          if (pr_title == undefined && !document.querySelector('.cart-drawer ').classList.contains('opened')) {
            Shopify.queue.push({
              variantId: app.pickYourPlan.frequency.frequencyId,
              prop: properties
            });
          }
        }
        // eslint-disable-next-line indent-legacy
        if (event.target.hasAttribute('packageProtectionProduct') && localStorage.getItem('frequencyQuantity') === 'null') {
          Shopify.queue.push({
            variantId: variantIdCustom
          });
        }
      } else if (event.target.hasAttribute('packageprotectionproduct') && window.location.href.includes('/cart')) {
        // eslint-disable-next-line indent-legacy
        console.log(event.target, 'packageProtectionProductpackageProtectionProductpackageProtectionProduct');
        Shopify.queue.push({
          variantId: variantIdCustom
        });
      }
      console.log(variantIdCustom, 'uper');
      Shopify.moveAlong = function () {
        var _this = this;

        console.log(variantIdCustom, Shopify.queue.length, 'upervariantIdCustomvariantIdCustom');
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          console.log(variantIdCustom, 'freeidvariantIdCustomvariantIdCustom');
          var request = Shopify.queue.shift();
          var dataAdd = {
            quantity: qtyValue,
            id: variantIdCustom,
            properties: {
              refSellingIDMainProduct: sellingId
            },
            selling_plan: sellingId
          };
          var cartData2 = {
            id: event.target.getAttribute('freevariantid'),
            quantity: 1
          };
          console.log(sellingId, 'sellingId');
          var cartData3 = {
            id: event.target.getAttribute('addontray'),
            quantity: qtyValue,
            properties: Object.assign({
              ref: variantIdCustom,
              refSellingID: sellingId
            }, !sellingId && { isSub: 'true' })
          };

          axios.post('/cart/add.js', dataAdd).then(function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
              var productPrice;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!(cartData2.id !== null)) {
                        _context.next = 3;
                        break;
                      }

                      _context.next = 3;
                      return axios.post('/cart/add.js', cartData2);

                    case 3:
                      if (!(cartData3.id !== null)) {
                        _context.next = 6;
                        break;
                      }

                      _context.next = 6;
                      return axios.post('/cart/add.js', cartData3);

                    case 6:

                      setTimeout(function () {
                        Shopify.moveAlong();
                      }, 1000);

                      if (app.isCartAdded === true) {
                        $current_button.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Please Wait').addClass('disabled');
                      }

                      setTimeout(function () {
                        if ($current_text.indexOf('No') < 0) {
                          $current_button.html('Added');
                        }
                        $('html').animate({
                          scrollTop: $('html').offset().top
                        }, 400);
                      }, 1000);

                      setTimeout(function () {
                        $current_button.html($current_text).removeClass('disabled');
                      }, 3000);

                      productPrice = app._formatMoney(response.data.price);


                      ttq.identify({
                        sha256_email: shaEmail,
                        sha256_phone_number: shaPhone
                      });

                      ttq.track('AddToCart', {
                        content_id: response.data.product_id,
                        content_type: 'product',
                        quantity: response.data.quantity,
                        price: productPrice,
                        value: window.theme.total_price,
                        currency: 'USD'
                      });

                      ttq.track('Subscribe', {
                        content_id: response.data.product_id,
                        content_type: 'product'
                      });
                      ttq.track('InitiateCheckout', {
                        content_id: response.data.product_id,
                        content_type: 'product_group',
                        value: window.theme.total_price,
                        currency: 'USD',
                        quantity: response.data.quantity
                      });

                      return _context.abrupt("return", response.data);

                    case 16:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, _this);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function (error) {
            // Rollbar.error('Something went wrong', error);
            if (Shopify.queue.length) {
              Shopify.moveAlong();
            }
            throw error;
          });
        } else {
          if (app.currentTemplate === 'cart' && !app.isCartAjaxed) {
            // location.reload();
          }

          setTimeout(function () {
            if (reload === 'reload' || reload === 'no') {
              window.location.href = '/cart';
            } else {
              var drawerOpen = document.querySelector('.cart-drawer ');
              if (!drawerOpen.classList.contains('opened')) {
                app._toggleCartDrawer();
              }
            }
          }, 900);

          app._getCartData();
          app._vibrateDevice();
          $qtyEl.val(1); // reset qty input to 1
          app.$snotify.clear();

          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
          }, 500);
        }
      };
      // let found = app.cart.items.find(product => product.product_id == app.pickYourPlan.selectedProduct_id);
      // if(app.cart.items.length > 0){
      // if(found){
      //   axios.post('/cart/clear.js')
      //   .then((response) => {
      //     Shopify.moveAlong();
      //   })
      //   .catch((error) => {
      //     throw error;
      //   });
      //   // Shopify.clear(function(){

      //   // });
      // }else{
      //   Shopify.moveAlong();
      // }
      Shopify.moveAlong();
    },
    _addToCartPrepaid: function _addToCartPrepaid(variantId, event, reload, check) {
      var $current_button = $(event.currentTarget);
      var $current_text = $(event.currentTarget).text();
      var $form = $(event.currentTarget).closest(app.selectors.productForm);
      var $qtyEl = $form.find(app.selectors.qtyInput);
      var qtyValue = $qtyEl.val() || 1;
      var productCartLimit = $(event.currentTarget).attr('data-cart-limit') || null;
      var cartProduct = app.cart.items.find(function (x) {
        return x.variant_id === variantId;
      });
      var totalQty = cartProduct ? Number(qtyValue) + Number(cartProduct.quantity) : qtyValue;
      var properties = {};
      Shopify.queue = [];

      // add cart limit property
      if (productCartLimit) {
        properties.cart_limit = productCartLimit;
      }

      // check if item has product limit assigned
      if (app._productHasCartLimit(totalQty, productCartLimit)) {
        return;
      }

      app.isLoading = true;
      app.isCartAdded = true;
      app.loadingEvent = 'cartAdding';

      // Pass all properties to the cart line item
      $.each($('input[name*="properties"]').serializeArray(), function () {
        var name = this.name.replace('properties[', '').replace(']', '');
        properties[name] = this.value;
      });

      // ReCharge Integration
      // if product is a subscription one use the reCharge Discount VariantId
      if ('subscription_id' in properties) {
        properties.shipping_interval_frequency = $('[name="properties[shipping_interval_frequency]"]').val();
        variantId = app.reChargeDiscountVariantId;
      }

      // eslint-disable-next-line eqeqeq
      if (app.pickYourPrepaid.shipping_interval_frequency != '') {
        properties.shipping_interval_frequency = app.pickYourPrepaid.shipping_interval_frequency;
      }
      if (app.pickYourPrepaid.charge_interval_frequency != '') {
        properties.charge_interval_frequency = app.pickYourPrepaid.charge_interval_frequency;
      }

      // eslint-disable-next-line eqeqeq
      if (app.pickYourPrepaid.shipping_interval_unit_type != '') {
        properties.shipping_interval_unit_type = app.pickYourPrepaid.shipping_interval_unit_type;
      }

      // eslint-disable-next-line eqeqeq
      if (app.pickYourPrepaid.subscription_id != '') {
        properties.subscription_id = app.pickYourPrepaid.subscription_id;
      }
      properties.number_charges_until_expiration = 1;
      properties.state = app.pickYourPrepaid.grass.selectedState;
      // eslint-disable-next-line eqeqeq
      // if (variantId != '') {
      //   if(app.currentTemplate == 'product') {
      //     Shopify.queue.push({
      //       variantId,
      //       prop: properties,
      //     });
      //   } else {
      //     // push the default variantId to the Shopify queue
      //     Shopify.queue.push({
      //       variantId,
      //     });
      //     // eslint-disable-next-line eqeqeq
      //     if (app.pickYourPrepaid.frequency.frequencyId != '') {
      //       Shopify.queue.push({
      //         variantId: app.pickYourPrepaid.frequency.frequencyId,
      //         prop: properties,
      //       });
      //     }
      //   }
      // } else {
      //   // push the default variantId to the Shopify queue
      //   Shopify.queue.push({
      //     variantId: app.pickYourPrepaid.frequency.frequencyId,
      //     prop: properties,
      //   });
      // }
      Shopify.queue.push({});

      Shopify.moveAlong = function () {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          var request = Shopify.queue.shift();
          var dataAdd = {
            quantity: qtyValue,
            id: request.variantId,
            properties: request.prop
          };
          axios.post('/cart/add.js', dataAdd).then(function (response) {
            Shopify.moveAlong();
            if (app.isCartAdded = true) {
              $current_button.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Please Wait').addClass('disabled');
            }

            setTimeout(function () {
              if ($current_text.indexOf('No') < 0) {
                $current_button.html('Added');
              }
              $('html').animate({
                scrollTop: $('html').offset().top
              }, 400);
            }, 1000);

            setTimeout(function () {
              $current_button.html($current_text).removeClass('disabled');
            }, 3000);
            return response.data;
          }).catch(function (error) {
            console.log(error);
            // Rollbar.error('Something went wrong', error);
            if (Shopify.queue.length) {
              Shopify.moveAlong();
            }
            throw error;
          });
        } else {
          if (app.currentTemplate === 'cart' && !app.isCartAjaxed) {
            // location.reload();
          }
          setTimeout(function () {
            if (reload === 'reload' || reload === 'no') {
              window.location.href = '/cart';
            } else {
              app._toggleCartDrawer();
            }
          }, 900);
          var email = $current_button.parents('[gift_tray]').find('#gift_email').val();
          var gift_note = $current_button.parents('[gift_tray]').find('#gift_note').val();

          var cart_attributes = {
            attributes: {
              "Ricipient's Email": email,
              'Gift note': gift_note
            }
          };
          axios.post('/cart/update.js', cart_attributes).then(function (response) {});

          app._getCartData();

          app._vibrateDevice();
          $qtyEl.val(1); // reset qty input to 1
          app.$snotify.clear();
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
          }, 500);
        }
      };
      Shopify.moveAlong();
    },

    /**
     * Event to remove a variant from the cart
     *
     * @param  {number} itemId - line item index
     */
    _removeFromCart: function _removeFromCart(itemIndex, event, property, test) {
      console.log(property, 'propertypropertypropertypropertypropertyproperty');
      var $cartItem = $(event.currentTarget).parentsUntil(app.selectors.cartItem).parent();
      $cartItem.addClass('updating');
      var customLine = void 0;
      // eslint-disable-next-line promise/catch-or-return
      fetch('/cart.js').then(function (response) {
        return response.json();
      })
      // eslint-disable-next-line promise/always-return
      .then(function (cart) {
        console.log(cart.items);
        var index = cart.items.findIndex(function (entry) {
          return entry.properties.refSellingID == property;
        });
        customLine = index + 1;
        console.log(customLine, index, property, 'raman');
      });
      axios.post('/cart/change.js', {
        quantity: 0,
        line: itemIndex
      }).then(function () {
        if (customLine != 0 && !test) {
          return axios.post('/cart/change.js', {
            quantity: 0,
            line: customLine
          });
        }
      }).then(function (response) {
        app.isLoading = false;
        app._getCartData();
        $('[data-toggle="tooltip"]').tooltip('hide');
      }).catch(function (error) {
        // console.log(error)
        // Rollbar.error('Something went wrong in removing cart item', error);
        throw error;
      });
    },


    /**
     * Event to update a variant in the cart
     *
     * @param  {number} itemIndex - line item index
     */
    _updateCart: function _updateCart(itemIndex, event, propertiess) {
      console.log(propertiess, 'fdfadfadfszdd');
      var $qtyEl = $(event.currentTarget).parentsUntil(app.selectors.qtyContainer).find(app.selectors.qtyInput);
      var $cartItem = $(event.currentTarget).closest(app.selectors.cartItem);
      var productCartLimit = $cartItem.data('cart-limit') || null;
      var qtyValue = $qtyEl.val();

      if ($(event.currentTarget).data('qty-decrease') !== undefined) {
        if (parseFloat(qtyValue) >= 2) {
          qtyValue = parseFloat(qtyValue) - 1;
        }
      } else if ($(event.currentTarget).data('qty-increase') !== undefined) {
        qtyValue = parseFloat(qtyValue) + 1;

        // check if item has product limit assigned
        if (app._productHasCartLimit(qtyValue, productCartLimit)) {
          return;
        }
      }

      app.isLoading = true;
      $cartItem.addClass('updating');

      $($qtyEl).parent().css({
        'pointer-events': 'none'
      });
      var customLines = void 0;
      // eslint-disable-next-line promise/catch-or-return
      fetch('/cart.js').then(function (response) {
        return response.json();
      })
      // eslint-disable-next-line promise/always-return
      .then(function (cart) {
        console.log(cart.items);
        var index = cart.items.findIndex(function (entry) {
          return entry.properties.refSellingID == propertiess;
        });
        customLines = index + 1;
        console.log(customLines, index, propertiess, 'raman');
      });
      axios.post('/cart/change.js', {
        quantity: qtyValue,
        line: itemIndex
      }).then(function () {
        // eslint-disable-next-line promise/always-return
        if (customLines != 0) {
          return axios.post('/cart/change.js', {
            quantity: qtyValue,
            line: customLines
          });
        }
      }).then(function (response) {

        app._getCartData();
        app.isLoading = false;
        $cartItem.removeClass('updating');
        $($qtyEl).parent().css({
          'pointer-events': 'inherit'
        });
        return response;
      }).catch(function (error, text) {
        // Rollbar.error('Something went wrong in updating cart item', error);
        app.isLoading = false;
        app._snotifyMsg('Error', 'Product is sold out.', 'Error');
        throw error;
      });
    },
    _productHasCartLimit: function _productHasCartLimit(qtyValue, productCartLimit) {
      if (productCartLimit) {
        if (qtyValue > productCartLimit) {
          app.$snotify.warning("Product cart limit applies for the specific product variant. You can't purchase more than " + productCartLimit + " item(s) per order.", 'Product Limit', {
            timeout: 10000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            buttons: [{
              text: 'Close',
              bold: true,
              closeOnClick: true
            }]
          });
          return true;
        }
      }
      return false;
    },
    _initmotivationbar: function _initmotivationbar() {
      var sell_limit = Number(app.salesMotivator.salesLimit);
      var cart_total = app.cart.total_price;
      var hasFreeShip = app.cart.items.filter(function (x) {
        return x.tags.indexOf('freeship') > -1 || x.tags.indexOf('free-shipping') > -1;
      }).length > 0;
      if (app.cart.total_price != 0) {
        cart_total = app.cart.total_price / 100;
      }
      if (cart_total >= sell_limit || hasFreeShip) {
        app.cart.motivationbartext = app.salesMotivator.topbarSuccessText;
        app.cart.motivationbarpercentage = 100 + "%";
      } else if (cart_total < sell_limit) {
        var result = parseFloat(100 - cart_total * 100 / sell_limit).toFixed(2);
        var away_price = app._formatMoney((sell_limit - cart_total) * 100);
        result = 100 - result;
        app.cart.motivationbarpercentage = result + "%";
        app.cart.motivationbartext = away_price + " " + app.salesMotivator.topbarInitialText;
      }
    },


    /**
     * Vibrate mobile device
     */
    _vibrateDevice: function _vibrateDevice() {
      // check for vibration support
      var vibrationEnabled = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
      if (vibrationEnabled) {
        navigator.vibrate(100);
      }
    },
    _snotifyMsg: function _snotifyMsg(title, msg, type) {
      if (type === 'Success') {
        app.$snotify.success(msg, title, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          buttons: [{
            text: 'Close',
            bold: true,
            closeOnClick: true
          }]
        });
      } else if (type === 'Error') {
        app.$snotify.error(msg, title, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          buttons: [{
            text: 'Close',
            bold: true,
            closeOnClick: true
          }]
        });
      }
    },
    _addpackage: function _addpackage(event) {
      var numberToFind = localStorage.getItem('frequencyQuantity');
      var selectElement = event.target.closest('.subscription-desc').querySelector('#fake_shipping_interval_frequency_');
      var sellingID = null;
      for (var i = 0; i < selectElement.options.length; i++) {
        var option = selectElement.options[i];

        // Check if the text content of the option matches the number to find
        if (option.text.trim() === numberToFind) {
          sellingID = option.value;
          break;
        }
      }
      var varId = event.target.closest('.subscription-desc').querySelector('#fake_shipping_interval_frequency_').getAttribute('variant-id');
      // Log the matching option value to the console
      console.log(sellingID, 'matchingOptionValue');
      // let cartItem = window.theme.cart;
      // console.log('cart', cartItem[0].selling_plan_allocation.selling_plan.options[0].value.split(' ')[0]);
      // const selected_package = $('[package_variant]').val();
      // const package_frequency = $('[package_variant]').find('option:selected').attr('title');
      // let selected_package_frequency = '1';

      // if (package_frequency.indexOf('2') > -1) {
      //   selected_package_frequency = '2';
      // } else if (package_frequency.indexOf('3') > -1) {
      //   selected_package_frequency = '3';
      // } else if (package_frequency.indexOf('4') > -1) {
      //   selected_package_frequency = '4';
      // }
      // app.reChargeDiscountVariantId = $('[package_variant]').find('option:selected').attr('data-discount-variant-id');
      // $('[package_frequency]').val(selected_package_frequency);
      localStorage.setItem('packageProtectionVarId', varId);
      app._addToCart(sellingID, event);
      console.log(event.target.closest('.subscription-desc').querySelector('#fake_shipping_interval_frequency_'), 'selected_package, event');
    }
  }
};

export default cartMethods;